const STORAGE_KEY = "enableDev";
const CHANGE_EVENT = "dev-menu-change";

export const DEV_LOGIN = "SENTRYDEV";

export const isDevMenuEnabled = () => !!localStorage.getItem(STORAGE_KEY);

export const toggleDevMenu = () => {
    if (isDevMenuEnabled()) {
        localStorage.removeItem(STORAGE_KEY);
    } else {
        localStorage.setItem(STORAGE_KEY, "active");
    }

    window.dispatchEvent(new Event(CHANGE_EVENT));
};

export const subscribeDevMenu = (callback) => {
    window.addEventListener(CHANGE_EVENT, callback);
    window.addEventListener("storage", callback);

    return () => {
        window.removeEventListener(CHANGE_EVENT, callback);
        window.removeEventListener("storage", callback);
    };
};
